module.exports = __webpack_public_path__ + "img/c01_unittechgastrapheteschampion_Normal_ua.f503af40.webp";